import flarebase from 'flarebase'


class WiaryAuth extends flarebase.auth.Auth {
  constructor() {
    super();
  }
}

var auth = new WiaryAuth();

auth.on('result', async (result) => {
  if (!result.user) return ;


});

auth.on('fail', (e) => {
  spat.modal.alert(e.message);
});


export default auth;